import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class WaremaTranslationLoader implements TranslateLoader {
    constructor(
        private readonly _http: HttpClient,
        private readonly _prefix = './assets/i18n/',
        private readonly _suffix = '.json',
    ) {}

    public getTranslation(lang: string): Observable<TranslationObject> {
        return this._http
            .get<TranslationObject>(`${this._prefix}${lang}${this._suffix}`)
            .pipe(map(result => this._process(result, lang)));
    }

    private _process(object: TranslationObject, lang: string): TranslationObject {
        const newObject: TranslationObject = {};

        for (const key of Object.keys(object)) {
            if (typeof object[key] === 'object') {
                newObject[key] = this._process(object[key] as TranslationObject, lang);
            } else if (typeof object[key] === 'string' && object[key] === '') {
                newObject[key] = `${key} ${lang.toUpperCase()}`;
            } else {
                newObject[key] = object[key];
            }
        }

        return newObject;
    }
}
